import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { TildePagosDevelopersPage } from '@/components/marketing/TildePagosDevelopersPage';

export const Route = createFileRoute('/_public/developers/pagos')({
  component: TildePagosDevelopersRoute,
});

function TildePagosDevelopersRoute(): JSX.Element {
  return (
    <MarketingShell currentPath="/developers">
      <TildePagosDevelopersPage />
    </MarketingShell>
  );
}
